
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/customization/focus-visible",
      function () {
        return require("private-next-pages/material-ui/customization/focus-visible.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/customization/focus-visible"])
      });
    }
  